async function queueRequests<T = unknown>(
    requests: (() => Promise<T>)[],
    limit = 10,
): Promise<T[]> {
    const queue: Promise<T>[] = [];
    for (const request of requests) {
        const promise = request().then((result) => {
            queue.splice(queue.indexOf(promise), 1);
            return result;
        });

        queue.push(promise);

        if (queue.length >= limit) {
            await Promise.race(queue);
        }
    }

    return Promise.all(queue);
}

export default queueRequests;
